import { AfterViewChecked, AfterViewInit, Component, ElementRef, signal, ChangeDetectionStrategy, input, output, viewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatFormFieldAppearance, MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { ThemePalette } from '@angular/material/core';

@Component({
	selector: 'ara-paginator',
	imports: [MatPaginator, TranslocoDirective, FormsModule, MatLabel, ReactiveFormsModule, MatFormFieldModule, MatInputModule],
	templateUrl: './ara-paginator.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './ara-paginator.component.scss',
})
export class AraPaginatorComponent implements AfterViewInit, AfterViewChecked {
	readonly length = input<number>(undefined);
	readonly pageIndex = input<number>(undefined);
	readonly pageSizeOptions = input<number[]>(undefined);
	readonly pageSize = input<number>(undefined);
	readonly totalPages = input<number>(undefined);
	readonly showFirstLastButtons = input<boolean>(undefined);
	readonly page = output<PageEvent>();
	readonly paginator = viewChild(MatPaginator);
	readonly araPaginator = viewChild<ElementRef>('araPaginator');

	readonly color = input<ThemePalette>(undefined);
	_formFieldAppearance?: MatFormFieldAppearance;

	maxPage = signal(0);

	constructor() {}

	ngAfterViewInit() {
		const paginator = this.paginator();
		paginator.pageIndex = this.pageIndex();
		paginator.pageSize = this.pageSize();
		paginator.length = this.length();
		paginator.page.subscribe((event: PageEvent) => {
			this.page.emit(event);
		});
	}

	ngAfterViewChecked() {
		const paginator = this.paginator();
		if (paginator) {
			this.maxPage.set(Math.ceil(paginator.length / paginator.pageSize));
		}
	}

	// Function to handle input change
	onInputChange(event: any) {
		const paginator = this.paginator();
		let value = event.target.value;
		if (value < 0) {
			event.target.value = 1;
			value = 1;
		} else if (value > this.maxPage()) {
			event.target.value = this.maxPage();
			value = this.maxPage();
		}
		paginator.pageIndex = value - 1;
		paginator.page.emit({
			pageIndex: paginator.pageIndex,
			pageSize: paginator.pageSize,
			length: paginator.length,
		});
		// reload data
		this.page.emit({
			pageIndex: paginator.pageIndex,
			pageSize: paginator.pageSize,
			length: paginator.length,
		});
	}
}
